// src/components/MobileNav.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

// Custom Link component that scrolls to top when clicked
const ScrollLink = ({ to, children, onClick, ...props }) => {
  const handleClick = (e) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (onClick) onClick(e);
  };

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
};

const MobileNavContainer = styled.div`
  display: none;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: block;
  }
`;

const HamburgerButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
`;

const HamburgerLine = styled.div`
  width: 2rem;
  height: 0.25rem;
  background: ${props => props.theme.colors.primary};
  border-radius: 10px;
  transition: all 0.3s linear;
  position: relative;
  transform-origin: 1px;

  :first-child {
    transform: ${({ $isOpen }) => $isOpen ? 'rotate(45deg)' : 'rotate(0)'};
  }

  :nth-child(2) {
    opacity: ${({ $isOpen }) => $isOpen ? '0' : '1'};
  }

  :nth-child(3) {
    transform: ${({ $isOpen }) => $isOpen ? 'rotate(-45deg)' : 'rotate(0)'};
  }
`;

const MobileMenu = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background: ${props => props.theme.colors.primary};
  z-index: 9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const MobileNavLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const MobileNavLink = styled(ScrollLink)`
  color: white;
  font-size: 1.5rem;
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    color: ${props => props.theme.colors.accent};
  }
`;

const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  
  const closeMenu = () => {
    setIsOpen(false);
  };
  
  return (
    <MobileNavContainer>
      <HamburgerButton onClick={toggleMenu}>
        <HamburgerLine $isOpen={isOpen} />
        <HamburgerLine $isOpen={isOpen} />
        <HamburgerLine $isOpen={isOpen} />
      </HamburgerButton>
      
      <AnimatePresence>
        {isOpen && (
          <MobileMenu
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
          >
            <MobileNavLinks>
              <MobileNavLink to="/" onClick={closeMenu}>Home</MobileNavLink>
              <MobileNavLink to="/about" onClick={closeMenu}>About</MobileNavLink>
              <MobileNavLink to="/services" onClick={closeMenu}>Services</MobileNavLink>
              <MobileNavLink to="/contact" onClick={closeMenu}>Contact</MobileNavLink>
            </MobileNavLinks>
          </MobileMenu>
        )}
      </AnimatePresence>
    </MobileNavContainer>
  );
};

export default MobileNav;